import { createSharedMemo } from '@orangelv/utils'

export const sharedMemo = createSharedMemo()
